import { ApolloError, QueryResult, useQuery, useMutation } from '@apollo/client';
import { FavoriteResource } from '@monorepo/shared/src/providers/ResourcesProvider/types';
import { StoreTypename } from 'types';
import REMOVE_FAVORITE_RESOURCE from '@monorepo/shared/src/graph/queries/resources/remove-favorite-resource-query';
import GET_FAVORITE_RESOURCES from '@monorepo/shared/src/graph/queries/resources/get-favorite-resources-query';

export type FavoriteResourcesState = {
  resources: FavoriteResource[];
  error: ApolloError | undefined;
  isLoading: boolean;
};
export type FavoriteResourcesStoreDispatch = {
  unpinResource: (favoriteResourceId: number) => Promise<void>;
};
export type FavotiteResourcesStore = [FavoriteResourcesState, FavoriteResourcesStoreDispatch];

export const getDefaultFavoriteResourcesState = (): { __typename: string } => ({
  __typename: StoreTypename.FAVORITE_RESOURCES,
});

const useFavoriteResourcesStore = (): FavotiteResourcesStore => {
  const { data, loading, error }: QueryResult<{ favorites: FavoriteResource[] }> = useQuery(
    GET_FAVORITE_RESOURCES,
    {}
  );

  const [mutateUnpinResource] = useMutation(REMOVE_FAVORITE_RESOURCE, {
    update(cache, { data: { deleteFavorite } }) {
      const existingFavoriteResources: { favorites: FavoriteResource[] } | null = cache.readQuery({
        query: GET_FAVORITE_RESOURCES,
      });
      const filteredFavoriteResources = existingFavoriteResources
        ? existingFavoriteResources.favorites.filter(
            (favorite: FavoriteResource) => favorite.id !== deleteFavorite.id
          )
        : [];
      cache.evict({
        fieldName: 'favorites',
        broadcast: false,
      });
      cache.writeQuery({
        query: GET_FAVORITE_RESOURCES,
        data: { favorites: filteredFavoriteResources },
      });
    },
  });

  return [
    {
      resources: data?.favorites || [],
      error,
      isLoading: loading,
    },
    {
      unpinResource: async (favoriteResourceId: number) => {
        try {
          await mutateUnpinResource({ variables: { data: { id: favoriteResourceId } } });
        } catch (error) {
          console.log(error);
        }
      },
    },
  ];
};

export default useFavoriteResourcesStore;
